import { Icon } from '@ui/components/elements';

interface CaretProps {
  direction: 'up' | 'down' | 'right';
}
export const Caret = ({ direction }: CaretProps) => {
  return (
    <Icon
      fileName={`ic_chevron_${direction}`}
      size="md"
      className="text-on-primary-surface-subdued"
    />
  );
};
